import { z } from "zod"

import { entityIdSchema } from "./identifiers.js"
import { payrollDataPurposeV1Schema } from "./payroll-data-governance-v1.js"

const providerIdSchema = z.string().regex(/^[A-Za-z0-9_.:-]{1,128}$/)
const dateSchema = z.string().regex(/^\d{4}-\d{2}-\d{2}$/)
const moneySchema = z.string().regex(/^(0|[1-9]\d{0,15})\.\d{2}$/)

export const payrollResultAccessActionV1Schema = z.enum(["view", "download"])

export const employeePayrollResultAccessV1Schema = z
  .object({
    accessEventId: entityIdSchema,
    runId: entityIdSchema,
    payrollProfileId: entityIdSchema,
    providerPaystubId: providerIdSchema,
    action: payrollResultAccessActionV1Schema,
    purpose: payrollDataPurposeV1Schema,
    stepUpAssertion: z.string().min(100).max(4096),
  })
  .strict()

export const employeePayrollResultV1Schema = z
  .object({
    entityType: z.literal("employee_payroll_result"),
    entityId: entityIdSchema,
    state: z.enum(["processing", "settled", "failed"]),
    version: z.literal(1),
    accessEventId: entityIdSchema,
    runId: entityIdSchema,
    workerId: entityIdSchema,
    payPeriodStart: dateSchema,
    payPeriodEnd: dateSchema,
    payDate: dateSchema.nullable(),
    currency: z.literal("USD"),
    grossAmount: moneySchema,
    taxAmount: moneySchema,
    deductionAmount: moneySchema,
    netAmount: moneySchema,
    documentStatus: z.enum(["unavailable", "available"]),
    authoritativeSource: z.literal("Worklio"),
    recalculated: z.literal(false),
    accessAudited: z.literal(true),
    downloadAuthorized: z.boolean(),
  })
  .strict()

export const payrollDocumentHandoffV1Schema = z
  .object({
    downloadUri: z.string().url().startsWith("https://"),
    expiresInSeconds: z.literal(10),
  })
  .strict()

export type EmployeePayrollResultAccessV1 = z.infer<
  typeof employeePayrollResultAccessV1Schema
>
export type EmployeePayrollResultV1 = z.infer<
  typeof employeePayrollResultV1Schema
>
export type PayrollDocumentHandoffV1 = z.infer<
  typeof payrollDocumentHandoffV1Schema
>
